// theme.js
import { extendTheme, withDefaultColorScheme } from "@chakra-ui/react";
// Version 1: Using objects
const customTheme = extendTheme(
	{
		styles: {
			global: {
				// styles for the `a`
				body: {
					color: "#12344D",
				},
				a: {
					color: "#2C5CC5",
					_hover: {
						textDecoration: "underline",
					},
				},
			},
		},
		colors: {
			primary: {
				500: "#264966",
			},
			secondary: {
				500: "linear-gradient(180deg, #FFFFFF 0%, #F5F7F9 100%)",
			},
			background: {
				primary: "#F5F7F9",
				secondary: "#fff",
				disabled: "#EBEFF3",
			},
		},
	},
	withDefaultColorScheme({
		colorScheme: "#264966",
		components: ["Button", "Badge"],
	})
);

export default customTheme;
